import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-skeleton-loader',
  templateUrl: './view-skeleton-loader.component.html',
  styleUrls: ['./view-skeleton-loader.component.scss']
})
export class ViewSkeletonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
